<template>
  <div class="row">
    <div class="small-12 columns"><h2>User Details Editor</h2></div>
    <div class="small-6 columns">Preassessment</div>
    <div class="small-6 columns">
      <VueScout
        v-model="preassessmentID"
        :multiple="false"
        :taggable="false"
        :options="preassessments"
        label="name"
      />
    </div>
    <div class="small-6 columns">User ID</div>
    <div class="small-6 columns"><input v-model="userID" type="text" /></div>
    <div class="small-12 columns">
      <button @click="getUserAttempt">Get User Attempt</button>
    </div>
    <div class="small-12 columns">
      <div class="row">
        <div class="row">
          <div v-if="userAttemptNotFound" class="small-12 columns">
            <h3>Attempt not found</h3>
          </div>
          <div class="small-6 columns">
            <div v-if="Object.keys(userAttempt).length > 0">
              {{ this.userAttempt }}
            </div>
          </div>
          <div class="small-6 columns">
            <button
              v-if="Object.keys(userAttempt).length > 0"
              @click="editYoutubelink"
            >
              edit
            </button>
          </div>
        </div>
      </div>
    </div>
    <sweet-modal ref="youtubereport" width="90%">
      <div class="row">
        <h3>Update User Details</h3>
        <div class="small-6 cil">Branch</div>
        <div class="small-12 columns">
          <VueScout
            v-model="userSelectedBranch"
            :multiple="false"
            :taggable="false"
            :options="hardcodedBranches"
            label="name"
          />
        </div>
        <div class="small-6 cil">Years</div>
        <div class="small-6 columns">
          <VueScout
            v-model="userSelectedYear"
            :multiple="false"
            :taggable="false"
            :options="hardcodedYears"
          />
        </div>
        <div class="small-12 columns">
          <button @click="updateYoutubeLink">Update User Details</button>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue"
import VueScout from "vue-scout"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueScout, SweetModal },
  data() {
    return {
      userID: undefined,
      preassessmentID: [],
      userSelectedBranch: [],
      userSelectedYear: [],
      preassessments: [],
      userAttempt: {},
      userAttemptNotFound: undefined,
      youtubelink: undefined,
      updatedYoutubeLink: undefined,
      hardcodedYears: [
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
      ],
      hardcodedBranches: [
        { code: "CIV", name: "CIV: CIVIL ENGINEERING" },
        { code: "EEE", name: "EEE: ELECTRICAL AND ELECTRONICS ENGINEERING " },
        { code: "INF", name: "INF: INFORMATION TECHNOLOGY" },
        { code: "MEC", name: "MEC: MECHANICAL ENGINEERING ENGNEERING " },
        { code: "CSE", name: "CSE: COMPUTER SCIENCE & ENGINEERING " },
        { code: "ECE", name: "ECE: ELECTRONICS AND COMMUNICATION ENGINEERING" },
        { code: "ANE", name: "ANE: AERONAUTICAL ENGINEERING " },
        { code: "BIO", name: "BIO: BIO-TECHNOLOGY (M.P.C. STREAM) " },
        { code: "CSS", name: "CSS: COMPUTER SCIENCE & SYSTEMS ENGINEERING " },
        {
          code: "DTD",
          name: "DTD: DIGITAL TECHNIQUES FOR DESIGN AND PLANNING ",
        },
        { code: "CEE", name: "CEE: CIVIL ENVIRONMENTAL ENGINEERING " },
        { code: "CHE", name: "CHE: CHEMICAL ENGINEERING" },
        { code: "CPE", name: "CPE: CHEMICAL PETRO ENGINEERING" },
        { code: "ECM", name: "ECM: ELECTRONICS AND COMPUTER ENGINEERING " },
        {
          code: "EIE",
          name: "EIE : ELECTRONICS AND INSTRUMENTATION ENGINEERING ",
        },
        { code: "GIN", name: "GIN: GEO-INFORMATICS " },
        { code: "MET", name: "MET: METALLURGICAL ENGINEERING " },
        { code: "MMT", name: "MMT: METALLURGY AND MATERIAL TECHNOLOGY " },
        { code: "ETM", name: "ETM: ELECTRNOICS & TELEMATICS " },
        { code: "FSP", name: "FSP: FACILITIES AND SERVICES PLANNING " },
        {
          code: "NMA",
          name: "NMA: NAVAL ARCHITECTURE AND MARINE ENGINEERING ",
        },
        { code: "PLG", name: "PLG: PLANNING ENGNEERING " },
        {
          code: "AEI",
          name: "AEI: APPLIED ELECTRONICS AND INSTRUMENTATION ENGG ",
        },
        { code: "AGR", name: "AGR : AGRICULTURAL ENGINEERING " },
        { code: "AUT", name: "AUT: AUTOMOBILE ENGINEERING " },
        { code: "BME", name: "BME: BIO-MEDICAL ENGINEERING " },
        { code: "CAB", name: "CAB: COMMERCIAL AGRICULTURAL & BUSINESS MGMT " },
        { code: "ECS", name: "ECS: ELECTRONICS CONTROL SYSTEMS ENGINEERING " },
        { code: "FDS", name: "FDS: FOOD SCIENCE " },
        { code: "CER", name: "CER : CHEMICAL (CERAMIC) TECHNOLOGY " },
        { code: "DRG", name: "DRG: DAIRYING " },
        { code: "FPT", name: "FPT : FOOD PROCESSING TECHNOLOGY " },
        { code: "ICE", name: "ICE: INSTRUMENTATION & CONTROL ENGINEERING " },
        {
          code: "IPE",
          name: "IPE: PRODUCTION / INDUSTRIAL PRODUCTION ENGINEERING ",
        },
        { code: "MIN", name: "MIN : MINING ENGINEERING " },
        { code: "TEX", name: "TEX : TEXTILE TECHNOLOGY PHARMACY COURSES " },
        {
          code: "IST",
          name: "IST : INSTRUMENTATION ENGINEERING / TECHNOLOGY ",
        },
        { code: "MCT", name: "MCT: MECHANICAL (MECHTRONICS) ENGINEERING" },
      ],
    }
  },
  mounted() {
    this.loadPreassessments()
  },
  methods: {
    updateYoutubeLink() {
      this.userAttempt.youtubelink = this.updatedYoutubeLink
      if (this.userSelectedBranch.length === 0) {
        this.userAttempt.branch = ""
      } else {
        this.userAttempt.branch = this.userSelectedBranch[0].name
      }

      if (this.userSelectedYear.length === 0) {
        this.userAttempt.year = ""
      } else {
        this.userAttempt.year = this.userSelectedYear[0]
      }

      this.axios({
        method: "post",
        url:
          `${siteConfig.siteURL}questions/pre/attempt/` +
          `-LH9tqOKDDNPrC-84BTe` +
          `/${this.userID}/${this.preassessmentID[0].id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { data: this.userAttempt },
      }).then(() => {
        this.$refs.youtubereport.close()
      })
    },
    editYoutubelink() {
      this.$refs.youtubereport.open()
    },
    getUserAttempt() {
      this.userAttemptNotFound = undefined
      this.userAttempt = {}
      this.axios({
        method: "get",
        url:
          `${siteConfig.siteURL}questions/p/` +
          `-LH9tqOKDDNPrC-84BTe` +
          `/${this.userID}/pre/${this.preassessmentID[0].id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        if (Object.keys(res.data.data.attempt.pre).length === 0) {
          this.userAttempt = {}
          this.userAttemptNotFound = true
          return
        }
        this.userAttempt = res.data.data.attempt.pre.data
        this.userAttemptNotFound = false

        for (let i = 0; i < this.hardcodedBranches.length; i++) {
          if (this.hardcodedBranches[i].name === this.userAttempt.branch) {
            this.userSelectedBranch = [this.hardcodedBranches[i]]
          }
        }
        if (!Array.isArray(this.userSelectedYear)) {
          this.userSelectedYear = []
        }
        this.userSelectedYear = [this.userAttempt.year]
      })
    },
    loadPreassessments() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}preassessments/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.preassessments = res.data.items
      })
    },
  },
}
</script>
